










import { defineComponent, PropType } from '@vue/composition-api'
import { getInvoicePdf } from '~/api/Agency/agency.api'
import { Invoice } from '~/api/Agency/agency.interface'
import IconButton from '~/components/IconButton.vue'

export default defineComponent({
  components: { IconButton },
  props: {
    item: { type: Object as PropType<Invoice>, required: true },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    async onClick() {
      try {
        this.loading = true
        const response = await getInvoicePdf(this.item.uuid)
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.download = 'invoices.pdf'
        link.click()
      } finally {
        this.loading = false
      }
    },
  },
})
